import { render, staticRenderFns } from "./RolesSettings.vue?vue&type=template&id=4fcaca8e&scoped=true"
import script from "./RolesSettings.vue?vue&type=script&lang=js"
export * from "./RolesSettings.vue?vue&type=script&lang=js"
import style0 from "./RolesSettings.vue?vue&type=style&index=0&id=4fcaca8e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcaca8e",
  null
  
)

export default component.exports